import React from "react";

export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="8" cy="8" r="7" fill="#4CAF50" />
      <path d="M6.5 10.5L4 8L3.2 8.8L6.5 12.1L13.5 5.1L12.7 4.3L6.5 10.5Z" fill="white" />
    </svg>
  );
};

export default CheckIcon;
